import React from 'react';
import { handleDummyAction } from '../../../../components/utils/Dummy';
const NextTreeContext = React.createContext({
    dispatch: handleDummyAction,
    state: {},
});
export default NextTreeContext;
